// interface containing terminal, Halle, Gate and Schalter data and their respectie labels
export interface terminalInfo {
  terminalLabel: string;
  hallLabel: string;
  gateLabel: string;
  exitLabel: string;
  checkinLabel: string;
  terminal?: string;
  halle?: string;
  gate?: string;
  exit?: string;
  schalter?: string;
}

/**
 * Render collected info about Terminal, Halle, Gate and Schalter if applicable
 *
 * @param {terminalInfo} params
 * @returns {string}
 */
export const renderTerminal = (params: terminalInfo): string => {
  const terminalInformation = [];

  if (params.terminal) terminalInformation.push(params.terminalLabel.replace("{0}", params.terminal));

  if (params.halle) terminalInformation.push(params.hallLabel.replace("{0}", params.halle));

  if (params.gate) terminalInformation.push(params.gateLabel.replace("{0}", params.gate));

  if (params.exit) terminalInformation.push(params.exitLabel.replace("{0}", params.exit));

  if (params.schalter) terminalInformation.push(params.checkinLabel.replace("{0}", params.schalter));

  return terminalInformation.join(", ");
};

export const renderTerminalHighlight = (terminalLabel: string): string => {
  const terminalHighlight = [
    {
      terminal: "1",
      color: "orange",
    },
    {
      terminal: "2",
      color: "turquoise",
    },
  ];

  return terminalHighlight.find(({ terminal }) => terminal === terminalLabel)?.color || "grey";
};
